















import Vue from "vue"
import { Component, Prop, Watch  } from "vue-property-decorator"

@Component
export default class UiInputRadio extends Vue {
    @Prop({ type: String, default: '' }) label: string
    @Prop({ type: String, default: '' }) id: string
    @Prop({ type: String, default: '' }) name: string
    @Prop({ type: String, default: '' }) value: string
    @Prop({ type: String, default: '' }) data: boolean

    change() {
        this.$emit('input', this.data)
    }
}
